import AppCSSService from "../../services/AppCSSService";
import { ServiceEmailCard } from "./uimodels/cards/ServiceEmailCard";
import { ServiceContactCard } from "./uimodels/cards/ServiceContactCard";
import { IDeviceStateControllerReturn } from "../../../../../commonreact/main/services/devicestate/DeviceStateController";
import CommonReactGUIElementsFactory from "../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory";
import Email from "../../../logic/models/Email";
import AppGUIElementsFactory from "../../factorys/AppGUIElementsFactory";
import { ServiceController } from "./ServiceController";
import { IModalOkCancelControllerReturn } from "../../../../../commonreact/main/components/modals/modalok/ModalOKCancelController";
import { IEditBaseControllerReturn } from "../../controllers/EditBaseController";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  mokc: IModalOkCancelControllerReturn;
  ebc: IEditBaseControllerReturn;
}

const Service = (props: IProps) => {
 //alert("SErvice")
  const email = Email.getFactory({ json: {} });

  //init controllers
  const sc = ServiceController({ mokcc: props.mokc, ebc: props.ebc, email: email });
  //init factorys
  const ef = CommonReactGUIElementsFactory.getFactory({ 
    keyStart: "service",
    FAddGlobal: () => {
      sc.handleEvents(); 
  }});
  const appf = AppGUIElementsFactory.getFactory({ ef: ef })


    //alert("ServiceContent")
    //const email = Email.getFactory({ json: {} });
  
    //init controllers
    // const sc = ServiceController({ mokcc: props.mokc, ebc: props.ebc, email: email });
    // //init factorys
    // const ef = CommonReactGUIElementsFactory.getFactory({ 
    //   keyStart: "service",
    //   FAddGlobal: () => {
    //     sc.handleEvents(); 
    // }});
    //const appf = AppGUIElementsFactory.getFactory({ ef: ef })
  
    return (
      <div className={`${AppCSSService.cardsWrapper} ${!props.dsc.small ? "w-4/5" : "w-full"} mt-4`}>
        <div className="w-full">
          <ServiceContactCard dsc={props.dsc} />
        </div>
        <div className="w-full">
          <ServiceEmailCard dsc={props.dsc} appf={appf} sc={sc} ebc={props.ebc} /> 
        </div>
      </div>
    
  );
};

export default Service;
